import { render } from "./BidShowcaseZaymna5.vue?vue&type=template&id=15b7365c&scoped=true"
import script from "./BidShowcaseZaymna5.vue?vue&type=script&lang=js"
export * from "./BidShowcaseZaymna5.vue?vue&type=script&lang=js"

import "./BidShowcaseZaymna5.vue?vue&type=style&index=0&id=15b7365c&scoped=true&lang=css"
import "./BidShowcaseZaymna5.vue?vue&type=style&index=1&id=15b7365c&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b7365c"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QForm,QInput});
